import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const PageTop = ({ title, brief, bg }: { title: string; brief: string; bg: string }) => {
  return (
    <div className={cx('top-container')}>
      <div className={cx('content')}>
        <div className={cx('title')}>{title}</div>
        <div className={cx('subtitle')}>{brief}</div>
      </div>
    </div>
  );
};
